export default __webpack_public_path__ + "0bd781676f67e6ceb86512b9616980ab.svg";